export const environment = {
  production: false,
  apiPrefix: "/rest/api/v2",
  batchPrefix: "/rest/batch/v2",
  realtimePrefix: "/rest/realtime/v2",
  servicesNlpPrefix: "/rest/services/nlp/v2",
  servicesOcrPrefix: "/rest/services/ocr/v2",
  servicesAiPrefix: "/rest/services/ai/v2"
};
